/**
 * Routerについて
 * 
 * - ルール
 * 		- ルートの指定はindex.jsに記述
 * 		- 画面別の荷関しては、modules以下に作成 (書き方はmodule以下を参照)
 * 		※module以下のjsは自動読み込みされます。
 * 
 * 参考
 * https://qiita.com/ultrasevenstar/items/6f543e84372def86ed69
 * 
 */
 //import * as Vue from 'vue'
 import * as VueRouter from 'vue-router'
 // import RegistrationRoutes from './modules/registration/customer-registration.js'
 //Vue.config.devtools = true;
 //Vue.use(VueRouter)
 const routes = [
	{
		path: '/app/',
		name: 'root',
		component: () => import('../layouts/MainLayout.vue'), // 使用するレイアウトの選択
		children: [
			{
				path: '', // 親と同じpathで表示するコンポーネントを下記で指定
				component: () => import(/* webpackChunkName: "login" */ '../components/dashboard/DashboardView.vue'),
				meta: { title:'YubiOn SecureFileTransfer | Dashboard'}
			},
		]
	},
	// {
	// 	path: '/requestresetpassword',
	// 	component: () => import('../layouts/LoginLayout.vue'), // 使用するレイアウトの選択
	// 	children: [
	// 		{
	// 			path: '', // 親と同じpathで表示するコンポーネントを下記で指定
	// 			name: 'ResetPassword',
	// 			component: () => import(/* webpackChunkName: "login" */ '../components/login/RequestResetPassword.vue'),
	// 			meta: { title:'YubiOn SecureFileTransfer | Reset password'}
	// 		},
	// 	]
	// },
	{
		path: '/app/*', // 定義外のものはすべて404エラーページに飛ばす。(必ず最後に読み込むこと。先に読み込まれると以降は/*にひっかかってしまう)
		component: () => import('../layouts/ErrorLayout.vue'), // 使用するレイアウトの選択
		children: [
			{
				path: '', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'NotFoundView',
				component: () => import(/* webpackChunkName: "notfound" */ '../components/error/NotFoundView.vue'),
				meta: { title:'YubiOn SecureFileTransfer | Not Found'}
			}
		]
	}
];

/**
 * ルーターモジュールを読み込む
 */
(() => { // eslint-disable-line
	// ルーター定義全取得
	const context = require.context("./modules", true, /([a-z_-]+)\.js$/i);

	// ルーター定義を格納
	context.keys().forEach(key => {
		let routeArr = context(key).default;
		routeArr.forEach(r => {
			// 404エラー定義を最後に読み込むため、配列の先頭から追加
			routes.unshift(r);
		});
	});
})();
/*
const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
*/
const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
	base: process.env.BASE_URL,
    routes
});

/**
 * 画面遷移時のモーダル背景の強制排除
 * モーダルを開いたままセッション切れなどで画面が強制移動した際、
 * <body> 直下に残ってしまう黒い幕とスクロールロックを解除する
 */
router.afterEach(() => {
	// 残ってしまった黒い幕をすべて強制削除
	const backdrops = document.querySelectorAll('.modal-backdrop');
	backdrops.forEach(backdrop => backdrop.remove());
	// bodyタグに付与されたままのスクロールロック用クラスとスタイルを解除
	document.body.classList.remove('modal-open');
	document.body.style.overflow = '';
	document.body.style.paddingRight = '';
});

export default router;
